import React, { useState } from 'react';
import { useEffect } from 'react';

import { Col,Container ,Row} from 'reactstrap';

const EditorTitle = ({ entity, detail }) => {
    const [title, setTitle] = useState('');
    useEffect(() => {
        const newTitle = entity.getTitle && detail ? entity.getTitle(detail) : "View " + entity.title;
        setTitle(newTitle);

    }, [detail, entity]);
    return <Container fluid style={{ width: '100%' }}>

        <Row>
            <Col>
                <h4>{title}</h4>
            </Col>
            <Col style={{ textAlign: 'right' }}><h4>{entity.title}</h4>
                <h5>{detail?.status}</h5>
            </Col>
        </Row>
    </Container>;
}

export default EditorTitle;